import Toastify from 'toastify-js';

class AppMessages {
  private static settings: Toastify.Options = {
    close: true,
    duration: 3000,
    gravity: 'bottom',
    offset: {
      x: 0,
      y: '2.5rem',
    },
    position: 'center',
  };

  private static create = function (message: string, options: Toastify.Options = {}) {
    const node = document.createElement('div');
    node.className = 'toast-content';
    node.innerText = message;

    Toastify({ ...AppMessages.settings, ...options, node }).showToast();
  };

  static error(message: string, options: Toastify.Options = {}) {
    AppMessages.create(message, {
      ...options,
      className: 'bg-state-error',
    });
  }
  static info(message: string, options: Toastify.Options = {}) {
    AppMessages.create(message, {
      ...options,
      className: 'bg-state-info',
    });
  }
  static success(message: string, options: Toastify.Options = {}) {
    AppMessages.create(message, {
      ...options,
      className: 'bg-state-success',
    });
  }
  static warn(message: string, options: Toastify.Options = {}) {
    AppMessages.create(message, {
      ...options,
      className: 'bg-state-warn',
    });
  }
}

export default AppMessages;
